import { nativeCommsMessageTypes } from ".";
import sharedNativeCommsReceiver from "./nativeCommsReceiver.shared";

const nativeCommsReceiver = (msg, data, store) => {
  const handled = sharedNativeCommsReceiver(msg, data, store);
  if (handled) {
    return;
  }
  // Get the current state out of the store
  // const state = store.getState().present;

  switch (msg) {
    // Tutorial Commands
    case nativeCommsMessageTypes.SHOW_TUTORIAL:
    case nativeCommsMessageTypes.SET_COMPLETED_TUTORIAL_STEPS:
    case nativeCommsMessageTypes.SET_TUTORIAL_SILENCED:
      // Received but doing nothing in readonly mode.
      break;
    default:
      console.error(`Unrecognized external message received: msg = ${msg}`); // eslint-disable-line no-console
      break;
  }
};

export default store => (msg, data) => nativeCommsReceiver(msg, data, store);
